'use strict';

const pfandVariantID = '44829305143494';

var pfandCount    = 0;
var pfandQuantity = 0;
var itemsCount    = 0;
var pfandSyncing  = false;
var pfandLastSync = 0;
var badgeObserver = null;

function hidePfandProduct() {
    document.querySelectorAll('[data-cartitem-id="' + pfandVariantID + '"]').forEach(function (el) {
    el.style.display = 'none';
    });
  document.querySelectorAll(
    '[data-variant-id="' + pfandVariantID + '"],' +
    '[data-id="' + pfandVariantID + '"]'
  ).forEach(function (el) {
    var row = el.closest('tr, li, .product-item, .grid__item, [class*="product"], [class*="cart-item"]');
    if (row) row.style.display = 'none';
  });
  document.querySelectorAll('a[href*="/products/german-pfand"], a[href*="/products/pfand"], a[href*="/products/pfand-0-25"]').forEach(function (el) {
    var row = el.closest('tr, li, .product-item, .grid__item, [class*="product"], [class*="cart-item"]');
    if (row) row.style.display = 'none';
  });
  document.querySelectorAll('input[value="' + pfandVariantID + '"]').forEach(function (el) {
    var row = el.closest('tr, li, [class*="cart-item"], [class*="line-item"]');
    if (row) row.style.display = 'none';
  });
}

function updateCartCount() {
  document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
    el.setAttribute('data-header-cart-count', itemsCount > 0 ? itemsCount : '');
    if (itemsCount > 0) { el.classList.add('visible'); } else { el.classList.remove('visible'); }
  });
  ['.cart-count','[data-cart-count]','.cart-item-count','.cart-count-bubble','.site-header__cart-count','.js-cart-count'].forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) { el.textContent = itemsCount || ''; });
  });
}

function watchBadge() {
  if (badgeObserver) return;
  var badge = document.querySelector('[data-header-cart-count]');
  if (!badge) return;
  badgeObserver = new MutationObserver(function () {
    if (itemsCount === 0) return;
    var current = parseInt(badge.getAttribute('data-header-cart-count') || '0', 10);
    if (current !== itemsCount) {
      badge.setAttribute('data-header-cart-count', itemsCount);
      badge.classList.add('visible');
    }
  });
  badgeObserver.observe(badge, { attributes: true, attributeFilter: ['data-header-cart-count'] });
}

async function refreshPfandMap() {
  try {
    const resp     = await fetch('/cart?sections=crevel-pfand-map');
    const sections = await resp.json();
    const html     = sections['crevel-pfand-map'];
    if (!html) { console.warn('[Crevel Pfand] section not found'); return; }
    const tmp    = document.createElement('div');
    tmp.innerHTML = html;
    const dataEl = tmp.querySelector('#crevel-pfand-section');
    if (!dataEl) return;
    const entries = JSON.parse(dataEl.textContent);
    if (entries.length === 0) return;
    const map = {};
    entries.forEach(function (e) { map[String(e.v)] = e.u; });
    window.CrEvelPfandMap = map;
    console.log('[Crevel Pfand] map:', map);
  } catch (err) {
    console.error('[Crevel Pfand] refreshPfandMap error:', err);
  }
}

function pfandAmountByItem(item) {
  var map = window.CrEvelPfandMap || {};
  if (map[String(item.variant_id)]) return map[String(item.variant_id)];
  return parseInt((item.properties && item.properties['_pfand_units']) || 0, 10);
}

async function syncPfand() {
  if (pfandSyncing) return;
  var now = Date.now();
  if (now - pfandLastSync < 4000) return;
  pfandSyncing  = true;
  pfandLastSync = now;

  var isDE = (document.body.getAttribute('data-crevel-country') || '') === 'DE';

  try {
    const [cartResp] = await Promise.all(
      isDE ? [fetch('/cart.js'), refreshPfandMap()] : [fetch('/cart.js')]
    );
    const cart = await cartResp.json();

    pfandCount = 0;
    itemsCount = 0;
    let pfandItem = null;

    Object.values(cart.items).forEach(function (item) {
      if (String(item.variant_id) === pfandVariantID) {
        pfandItem = item;
      } else {
        if (isDE) pfandCount += pfandAmountByItem(item) * item.quantity;
        itemsCount += item.quantity;
      }
    });

    updateCartCount();
    hidePfandProduct();

    pfandQuantity = pfandItem ? pfandItem.quantity : 0;
    console.log('[Crevel Pfand] isDE=' + isDE + ' required=' + pfandCount + ' current=' + pfandQuantity);

    if (pfandCount === pfandQuantity) return;

    var operation, body;
    if (!pfandItem && pfandCount > 0) {
      operation = 'add';
      body = JSON.stringify({ id: pfandVariantID, quantity: pfandCount });
    } else if (pfandItem) {
      operation = 'change';
      body = JSON.stringify({ id: pfandItem.key, quantity: pfandCount });
    } else {
      return;
    }

    await fetch(window.Shopify.routes.root + 'cart/' + operation + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    });

    updateCartCount();
    hidePfandProduct();

  } catch (err) {
    console.error('[Crevel Pfand] syncPfand error:', err);
  } finally {
    pfandSyncing = false;
  }
}

function observeCartChanges() {
  try {
    const observer = new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        const isAjax     = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartCall = /\/cart\//.test(entry.name);
        const isPfand    = entry.name.includes(pfandVariantID);
        if (isAjax && isCartCall && !isPfand) {
          setTimeout(syncPfand, 300);
        }
      });
    });
    observer.observe({ entryTypes: ['resource'] });
  } catch (e) {}
}

var cartObserver = new MutationObserver(hidePfandProduct);

console.log('[Crevel Pfand] script loaded');
document.addEventListener('DOMContentLoaded', function () {
  hidePfandProduct();
  syncPfand().then(watchBadge);
  observeCartChanges();
  setTimeout(hidePfandProduct, 1500);
  correctSubtotal();

  // REMOVE these lines ↓
  // document.querySelectorAll('[data-cart-total]').forEach(function(el) {
  //   new MutationObserver(correctSubtotal).observe(el, { childList: true, characterData: true, subtree: true });
  // });

  var cartEl = document.querySelector('[data-cart], .cart-items, #cart-items, form[action="/cart"]');
  if (cartEl) cartObserver.observe(cartEl, { childList: true, subtree: true });
});
document.documentElement.addEventListener('cart:refresh', function () {
  setTimeout(syncPfand, 400);
});
function correctSubtotal() {
  var pfandItem = null;
  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    pfandItem = cart.items.find(function(i) { return String(i.variant_id) === pfandVariantID; });
    var pfandPrice = pfandItem ? pfandItem.final_line_price : 0;
    var correctTotal = cart.total_price - pfandPrice;
        var moneyFormat = null;
    var sectionDataEl = document.querySelector('[data-section-data]');
    if (sectionDataEl) {
      try { moneyFormat = JSON.parse(sectionDataEl.textContent).money_format; } catch(e) {}
    }
    var formatted = (window.Shopify && window.Shopify.formatMoney && moneyFormat)
      ? window.Shopify.formatMoney(correctTotal, moneyFormat)
      : '\u20ac' + (correctTotal / 100).toFixed(2).replace('.', ',');
    document.querySelectorAll('[data-cart-total]').forEach(function(el) {
      el.textContent = formatted;
    });
  });
}